/* Carrito sin recargas: cajon lateral, pasos de cantidad y quitar.

   El contenido SIEMPRE lo arma Liquid. Aqui no hay plantillas: se pide
   la seccion ya renderizada con la API de secciones de Shopify
   (?sections=mz-cart-drawer) y se reemplaza el nodo. Una sola fuente de
   marcado, imposible que el cajon y la pagina se desincronicen.

   Todo lo que se intercepta son enlaces reales a /cart/change, asi que
   sin JavaScript la tienda sigue funcionando: recarga en vez de refrescar. */

/* ---------- pila de dialogos, compartida ----------

   El cajon del carrito y el pop-up de alta son dos guiones distintos de
   este mismo archivo, y cada uno tenia SU PROPIA trampa de foco
   escuchando focusin en el documento. Bastaba con tocar "Carrito" en la
   portada y esperar a que venciera el temporizador de los seis segundos:
   el pop-up se pintaba encima del cajon, la trampa del cajon devolvia el
   foco a su panel, ese focus disparaba otro focusin, la trampa del
   pop-up lo devolvia a su caja, y asi hasta reventar la pila de
   llamadas. Los dos dialogos quedaban muertos y solo Escape rescataba,
   que es justo lo que no sabe quien navega con el raton.

   Aqui hay UNA sola trampa para todos los dialogos del tema, y solo
   atiende al ULTIMO abierto. No puede haber pelea porque no hay dos
   guardianes: cualquier combinacion de cajon y pop-up, en cualquier
   orden, acaba con el foco dentro del de encima y ahi se queda.

   El bloqueo del scroll va por la pila y no con un add/remove ciego:
   antes, cerrar uno de los dos dialogos le devolvia el scroll a la
   pagina de detras con el otro todavia abierto, y el fondo se movia
   bajo el velo.

   El foco de cada dialogo se guarda como FUNCION, no como nodo: el
   cajon se reemplaza entero en cada refresco y un nodo memorizado
   apuntaria a un panel que ya no esta en el documento. */
window.mzDialogos = window.mzDialogos || (function () {
  'use strict';
  var pila = [];

  function cima() { return pila.length ? pila[pila.length - 1] : null; }

  document.addEventListener('focusin', function (ev) {
    var d = cima();
    if (!d) return;
    var f = d.foco();
    if (!f || !document.contains(f)) return;
    if (!f.contains(ev.target)) f.focus();
  });

  return {
    abrir: function (clave, foco) {
      for (var i = 0; i < pila.length; i++) {
        if (pila[i].clave === clave) { pila.splice(i, 1); break; }
      }
      pila.push({ clave: clave, foco: foco });
      document.documentElement.classList.add('mz-sin-scroll');
    },
    cerrar: function (clave) {
      for (var i = 0; i < pila.length; i++) {
        if (pila[i].clave === clave) { pila.splice(i, 1); break; }
      }
      if (!pila.length) document.documentElement.classList.remove('mz-sin-scroll');
    },
    hayAbierto: function () { return pila.length > 0; }
  };
})();

(function () {
  'use strict';

  var SECCION = 'mz-cart-drawer';
  var cajon, panel, disparador;

  function nodo() { return document.querySelector('[data-mz-cajon]'); }

  /* Se resuelve cada vez: el cajon se reemplaza entero en cada refresco,
     asi que el panel de hace un segundo ya no esta en el documento. */
  function focoCajon() {
    var c = nodo();
    return c && c.querySelector('.mz-cajon__panel');
  }

  /* ---------- abrir y cerrar ---------- */

  function abrir(desde) {
    cajon = nodo();
    if (!cajon) return;
    disparador = desde || document.activeElement;
    cajon.hidden = false;
    // Un cuadro de margen para que la transicion arranque desde el
    // estado cerrado en vez de aparecer ya abierta.
    requestAnimationFrame(function () {
      cajon.classList.add('is-abierto');
      // El scroll y la trampa de foco los lleva la pila compartida (ver
      // arriba): si el pop-up de alta se abre encima, no hay dos
      // guardianes peleandose el foco hasta desbordar la pila.
      window.mzDialogos.abrir('cajon', focoCajon);
      panel = cajon.querySelector('.mz-cajon__panel');
      if (panel) panel.focus();
    });
  }

  function cerrar() {
    cajon = nodo();
    if (!cajon || cajon.hidden) return;
    cajon.classList.remove('is-abierto');
    // Se da de baja ANTES de devolver el foco al disparador: si siguiera
    // en la pila, la trampa lo veria salir del panel y lo arrastraria de
    // vuelta a un cajon que se esta cerrando.
    window.mzDialogos.cerrar('cajon');
    var fin = function () { cajon.hidden = true; };
    // Si el usuario pidio menos movimiento no hay transicion que esperar.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) fin();
    else setTimeout(fin, 260);
    if (disparador && document.contains(disparador)) disparador.focus();
  }

  /* ---------- refrescar desde el servidor ---------- */

  function refrescar() {
    return fetch('/?sections=' + SECCION, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[SECCION];
        if (!html) return;
        var caja = document.createElement('div');
        caja.innerHTML = html;
        var nuevo = caja.querySelector('[data-mz-cajon]');
        var viejo = nodo();
        if (!nuevo || !viejo) return;
        var estaba = viejo.classList.contains('is-abierto');
        nuevo.hidden = viejo.hidden;
        if (estaba) nuevo.classList.add('is-abierto');
        viejo.parentNode.replaceChild(nuevo, viejo);
      });
  }

  /* Un solo sitio que diga lo que hay en el carrito.

     Habia dos funciones a medias: esta escribia la cifra y manejaba el
     hidden, y mzSetCartCount() escribia la etiqueta accesible, pero solo
     se la llamaba al agregar. Al pulsar "+" dentro del cajon la insignia
     enseñaba un 2 y su etiqueta seguia diciendo 1.

     Y el <span role="status"> del encabezado no lo tocaba NADIE en todo
     el tema. Ese span vive DENTRO del enlace del carrito, asi que forma
     parte de su nombre accesible: en cuanto la cifra cambiaba sin
     recargar, el enlace pasaba a llamarse "Carrito 2 Carrito vacio", una
     contradiccion literal. Liquid lo pinta bien en la carga y nadie lo
     mantenia despues; no tiene atributo de datos por el que agarrarlo,
     asi que se alcanza por su sitio dentro del boton. */
  function contador(n) {
    if (window.mzSetCartCount) window.mzSetCartCount(n);
    var badges = document.querySelectorAll('[data-mz-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      if (!window.mzSetCartCount) badges[i].textContent = n;
      badges[i].hidden = n === 0;
    }
    var estado = document.querySelector('.mz-cartbtn [role="status"]');
    if (estado) estado.textContent = n === 0 ? 'Carrito vacío' : n + ' en el carrito';
  }

  /* Si estamos EN la pagina del carrito, el cajon no basta: hay que
     rehacer tambien la lista y el resumen de la pagina. */
  function refrescarPagina() {
    if (!document.querySelector('[data-mz-cart-pagina]')) return Promise.resolve();
    return fetch(window.location.pathname, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var caja = document.createElement('div');
        caja.innerHTML = html;
        var nuevo = caja.querySelector('[data-mz-cart-pagina]');
        var viejo = document.querySelector('[data-mz-cart-pagina]');
        if (!nuevo || !viejo) return;
        conservar(viejo, nuevo);
        viejo.parentNode.replaceChild(nuevo, viejo);
        /* innerHTML no ejecuta los <script> del marcado nuevo: el calendario
           de entrega se queda sin vida si nadie lo vuelve a montar. Fue lo
           que paso hasta el 6-oct-2026: tras un + o - no abria y, siendo
           obligatorio, no se podia pagar. Ver snippets/mz-fecha-entrega. */
        if (window.mzFechaMontar) window.mzFechaMontar(nuevo);
      });
  }

  /* Lo que la persona tiene en pantalla manda sobre lo que pinto el
     servidor. La fecha y la nota se guardan en el carrito al elegirlas o
     al salir del campo, pero ese guardado puede no haber terminado cuando
     llega el repintado —un + justo despues de elegir dia— y entonces
     Liquid pinta el valor anterior. Se copian del bloque viejo al nuevo
     antes del reemplazo. */
  function conservar(viejo, nuevo) {
    ['attributes[Fecha de entrega]', 'note'].forEach(function (n) {
      var a = viejo.querySelector('[name="' + n + '"]');
      var b = nuevo.querySelector('[name="' + n + '"]');
      if (a && b) b.value = a.value;
    });
    var notaA = viejo.querySelector('details.mz-nota');
    var notaB = nuevo.querySelector('details.mz-nota');
    if (notaA && notaB) notaB.open = notaA.open;
  }

  /* ---------- guardar la nota y la fecha ----------

     Cambiar una cantidad vuelve a pedir la pagina y REEMPLAZA el bloque
     entero (ver refrescarPagina). Lo que estuviera escrito y sin enviar
     desaparece con el nodo viejo. Por eso ambos campos se guardan en el
     carrito al salir de ellos: al re-renderizar, Liquid los vuelve a
     pintar desde cart.note y cart.attributes y siguen ahi.

     Sin esto, alguien escribe la nota, ajusta una cantidad y la pierde
     sin que nada se lo diga. */
  function guardarEnCarrito(cuerpo) {
    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(raiz + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(cuerpo)
    }).catch(function () { /* si falla, el POST de Pagar lo lleva igual */ });
  }

  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t || !t.name) return;
    if (t.name === 'note') {
      guardarEnCarrito({ note: t.value });
    } else if (t.name.indexOf('attributes[') === 0) {
      var clave = t.name.slice(11, -1);
      var attrs = {};
      attrs[clave] = t.value;
      guardarEnCarrito({ attributes: attrs });
    }
  });

  /* ---------- foco, anuncio y scroll alrededor del reemplazo ----------

     Que el marcado lo arme siempre Liquid esta bien, pero reemplazar el
     nodo entero tiene tres costes que nadie estaba pagando.

     El foco: el boton que se acaba de pulsar se va con el nodo viejo, el
     navegador manda el foco al <body> sin disparar ningun evento, y con
     teclado cada "+" es de un solo uso —el siguiente Tab lleva a "Saltar
     al contenido"—. Dentro del cajon es peor: el foco sale del dialogo y
     se pasea por la pagina que hay detras del velo.

     El anuncio: la cantidad se pinta en .mz-paso__n, que trae
     aria-live="polite", pero ese nodo se destruye y se vuelve a crear en
     cada cambio, y una region viva recien insertada NO anuncia su
     contenido. El lector de pantalla no decia nunca la cantidad nueva.

     El scroll: .mz-cajon__cuerpo es overflow-y:auto y el nodo nuevo nace
     arriba, asi que quien quitaba el quinto de seis renglones acababa
     mirando el primero. */

  /* La referencia es la POSICION de la linea dentro de su lista, no el
     data-mz-line: cuando una linea se va, todas las de abajo cambian de
     indice y el numero memorizado apunta a otro producto. Por posicion,
     si la linea sobrevive el foco vuelve a su propio boton; si
     desaparecio —cantidad 0, o Quitar— cae en la que ocupa ahora su
     sitio, que es el siguiente renglon y es justo lo que se espera. */
  function papel(el) {
    if (el.classList.contains('mz-linea__quitar')) return 'quitar';
    var paso = el.closest('.mz-paso');
    if (!paso) return null;
    return paso.querySelectorAll('.mz-paso__b')[0] === el ? 'menos' : 'mas';
  }

  function anclar() {
    var el = document.activeElement;
    // Con el raton el foco suele quedarse en el <body>: no hay nada que
    // devolver y forzarlo seria meterse donde no llaman.
    if (!el || !el.closest) return null;
    var li = el.closest('.mz-linea');
    if (!li) return null;
    var caja = li.closest('[data-mz-cajon]') || li.closest('[data-mz-cart-pagina]');
    if (!caja) return null;
    var lineas = caja.querySelectorAll('.mz-linea');
    return {
      raiz: caja.hasAttribute('data-mz-cajon') ? '[data-mz-cajon]' : '[data-mz-cart-pagina]',
      pos: Array.prototype.indexOf.call(lineas, li),
      papel: papel(el)
    };
  }

  function devolverFoco(a) {
    if (!a) return;
    var caja = document.querySelector(a.raiz);
    if (!caja) return;
    var lineas = caja.querySelectorAll('.mz-linea');
    var li = lineas[a.pos] || lineas[lineas.length - 1];
    var destino = null;
    if (li) {
      if (a.papel === 'quitar') destino = li.querySelector('.mz-linea__quitar');
      else {
        var bs = li.querySelectorAll('.mz-paso__b');
        destino = a.papel === 'mas' ? bs[1] : bs[0];
      }
      if (!destino) destino = li.querySelector('a, button');
    }
    // Si ya no queda ni un renglon (se vacio la canasta), al panel del
    // cajon, que sigue siendo el dialogo; en la pagina, a lo primero que
    // quede del bloque.
    if (!destino) destino = caja.querySelector('.mz-cajon__panel') || caja.querySelector('a, button');
    if (destino) destino.focus();
  }

  /* Esta region viva SOBREVIVE al reemplazo porque cuelga del <body>,
     que no se sustituye nunca. Es la unica que llega a anunciarse. */
  var vivo;
  function anunciar(texto) {
    if (!vivo) {
      vivo = document.createElement('p');
      vivo.className = 'mz-visually-hidden';
      vivo.setAttribute('role', 'status');
      vivo.setAttribute('aria-live', 'polite');
      document.body.appendChild(vivo);
    }
    vivo.textContent = texto;
  }

  /* ---------- cambiar cantidades ---------- */

  var ocupado = false;

  function cambiar(linea, cantidad, origen) {
    if (ocupado) return;
    ocupado = true;
    if (origen) origen.classList.add('is-cargando');
    // El nombre se lee ANTES de pedir nada: si la cantidad baja a cero,
    // el renglon que lo dice ya no existira cuando toque anunciarlo.
    var li = origen && origen.closest ? origen.closest('.mz-linea') : null;
    var quien = li && li.querySelector('.mz-linea__nombre');
    var nombre = quien ? (quien.textContent || '').trim() : 'El artículo';
    var ancla = anclar();
    var cuerpo = document.querySelector('.mz-cajon__cuerpo');
    var alto = cuerpo ? cuerpo.scrollTop : 0;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: linea, quantity: cantidad })
    })
      .then(function (r) { return r.json(); })
      .then(function (carrito) {
        contador(carrito.item_count);
        return Promise.all([refrescar(), refrescarPagina()]);
      })
      .then(function () {
        // Dentro de su propio try: un tropiezo devolviendo el foco no
        // merece la recarga del .catch, que le costaria a la persona el
        // sitio donde estaba mirando.
        try {
          var c2 = document.querySelector('.mz-cajon__cuerpo');
          if (c2) c2.scrollTop = alto;
          devolverFoco(ancla);
          anunciar(cantidad === 0
            ? nombre + ', quitado de tu canasta.'
            : nombre + ', cantidad ' + cantidad + '.');
        } catch (e) {}
      })
      .catch(function () {
        // Si algo falla, la recarga deja al cliente en un estado real en
        // vez de en una lista que miente sobre lo que tiene.
        window.location.reload();
      })
      .then(function () { ocupado = false; });
  }

  /* ---------- agregar al carrito ---------- */

  /* El aviso de error, VISIBLE.

     [data-mz-live] es .mz-visually-hidden: mide un pixel. Cuando la red
     se cae a medio "Agregar al carrito" —4G del metro, elevador, zona
     muerta—, el texto del fallo entraba ahi y no lo veia nadie: el boton
     parpadeaba, el cajon no se abria, la insignia no cambiaba y la
     persona volvia a tocar sin enterarse nunca de por que su canasta
     seguia vacia. El camino de exito si tiene respaldo visual (se abre
     el cajon); el de error no tenia ninguno.

     El texto se queda ademas donde estaba, para el lector de pantalla.
     Y el nodo visible se cuelga del bloque de compra, no del <form>:
     Liquid suelta ese bloque en dos sitios distintos segun haya armador
     de sabores, y colgarlo del formulario lo sacaria donde no toca en
     las canastas. */
  function verError(form, aviso, boton, texto) {
    var caja = (aviso && aviso.parentNode) || (boton && boton.parentNode) || form;
    var p = caja.querySelector('[data-mz-error]');
    // Se retira en vez de ocultarse: un <p> vacio con hidden depende de
    // que ninguna regla de autor le ponga un display, y aqui no hace
    // falta correr ese riesgo.
    if (!texto) { if (p) p.parentNode.removeChild(p); return; }
    if (!p) {
      p = document.createElement('p');
      p.className = 'mz-error';
      p.setAttribute('data-mz-error', '');
      caja.appendChild(p);
    }
    p.textContent = texto;
  }

  function agregar(form) {
    if (ocupado) return;
    ocupado = true;
    var boton = form.querySelector('[type="submit"]');
    var aviso = form.querySelector('[data-mz-live]');
    if (boton) { boton.classList.add('is-cargando'); boton.setAttribute('aria-disabled', 'true'); }
    // El error del intento anterior se va al empezar el siguiente: si se
    // quedara, un exito parecería un fallo.
    verError(form, aviso, boton, '');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (carrito) {
        contador(carrito.item_count);
        if (aviso) aviso.textContent = 'Agregado a tu canasta.';
        return refrescar();
      })
      .then(function () {
        abrir(boton);
      })
      .catch(function (e) {
        // Sin existencias o variante invalida: el mensaje lo pone Shopify.
        // Si no hay ni un sitio donde enseñarlo, se envia el formulario de
        // verdad y que lo resuelva la pagina del carrito.
        var msg = (e && e.description) || 'No se pudo agregar. Inténtalo de nuevo.';
        if (!aviso && !boton) { form.submit(); return; }
        if (aviso) aviso.textContent = msg;
        verError(form, aviso, boton, msg);
      })
      .then(function () {
        ocupado = false;
        if (boton) { boton.classList.remove('is-cargando'); boton.removeAttribute('aria-disabled'); }
      });
  }

  /* ---------- enganches ---------- */

  document.addEventListener('click', function (ev) {
    var abridor = ev.target.closest('[data-mz-abrir-cajon]');
    if (abridor) {
      // Si el cajon YA esta abierto, el segundo clic no lo vuelve a abrir:
      // deja pasar el enlace y lleva a la pagina completa del carrito.
      var c = nodo();
      if (c && !c.hidden && c.classList.contains('is-abierto')) return;
      ev.preventDefault();
      abrir(abridor);
      return;
    }

    if (ev.target.closest('[data-mz-cajon-cerrar]')) { ev.preventDefault(); cerrar(); return; }

    var paso = ev.target.closest('[data-mz-qty]');
    if (paso) {
      ev.preventDefault();
      cambiar(parseInt(paso.getAttribute('data-mz-line'), 10),
              parseInt(paso.getAttribute('data-mz-qty'), 10),
              paso);
    }
  });

  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form.matches('[data-mz-add-form]')) return;
    ev.preventDefault();
    agregar(form);
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape') return;
    var c = nodo();
    if (c && !c.hidden) cerrar();
  });

  /* La trampa de foco del cajon ya no vive aqui: es la de la pila
     compartida del principio del archivo, que atiende solo al dialogo de
     encima. Dos trampas independientes se llamaban la una a la otra. */
})();

/* Barra de aviso: una vez por sesion del navegador, y solo en la portada
   (de eso se encarga el Liquid). Se marca en sessionStorage, no en
   localStorage: sessionStorage muere al cerrar el navegador, asi que
   quien vuelve al dia siguiente la ve otra vez, que es lo pedido.

   Nace con el atributo hidden y el guion la descubre. Si no hay
   JavaScript no se muestra nunca: es un aviso promocional, no
   contenido, y prefiero que falte a que se quede pegado sin poder
   cerrarlo. */
(function () {
  'use strict';
  var LLAVE = 'mz-aviso-visto';
  var barra = document.querySelector('[data-mz-anuncio]');
  if (!barra) return;

  function visto() {
    try { return sessionStorage.getItem(LLAVE) === '1'; } catch (e) { return false; }
  }
  function marcar() {
    try { sessionStorage.setItem(LLAVE, '1'); } catch (e) { /* sin memoria, ni modo */ }
  }

  if (visto()) return;
  barra.hidden = false;
  marcar();

  document.addEventListener('click', function (ev) {
    if (!ev.target.closest('[data-mz-anuncio-cerrar]')) return;
    barra.remove();
  });
})();

/* Pop-up de alta a la lista.

   Una vez por SESIÓN del navegador, y solo en la portada (de eso se
   encarga el Liquid). sessionStorage y no localStorage a propósito:
   sessionStorage se borra al cerrar el navegador, así que quien vuelve
   al día siguiente lo ve otra vez. localStorage habría sobrevivido
   semanas.

   Se marca al MOSTRARLO, no al cerrarlo: si se marcara al cerrar,
   recargar la portada lo volvería a lanzar. */
(function () {
  'use strict';

  var LLAVE = 'mz-alta-visto';
  var pop = document.querySelector('[data-mz-pop]');
  if (!pop) return;

  function visto() {
    try { return sessionStorage.getItem(LLAVE) === '1'; } catch (e) { return false; }
  }
  function marcar() {
    try { sessionStorage.setItem(LLAVE, '1'); } catch (e) { /* sin memoria, ni modo */ }
  }

  var caja = pop.querySelector('.mz-pop__caja');
  var espera = parseInt(pop.getAttribute('data-mz-pop-espera'), 10);
  if (isNaN(espera)) espera = 6;
  var antes;

  function focoPop() { return caja; }

  function abrir() {
    if (!pop.hidden) return;
    marcar();
    antes = document.activeElement;
    pop.hidden = false;
    requestAnimationFrame(function () {
      pop.classList.add('is-abierto');
      // El scroll y la trampa de foco los lleva la pila compartida del
      // principio del archivo, que atiende solo al dialogo de encima.
      window.mzDialogos.abrir('pop', focoPop);
      if (caja) caja.focus();
    });
  }

  function cerrar() {
    pop.classList.remove('is-abierto');
    // Baja de la pila ANTES de devolver el foco: si el cajon estaba
    // abierto debajo, el foco vuelve alli y manda el cajon otra vez. Y el
    // scroll de la pagina no se desbloquea mientras quede algo abierto.
    window.mzDialogos.cerrar('pop');
    var fin = function () { pop.hidden = true; };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) fin();
    else setTimeout(fin, 240);
    if (antes && document.contains(antes)) antes.focus();
  }

  /* Si el alta acaba de ocurrir, Shopify recarga la pagina con el
     resultado dentro. Se abre de inmediato —y sin mirar sessionStorage—
     porque la persona acaba de enviar algo y tiene derecho a ver que
     paso, aunque el pop-up ya se le hubiera mostrado esta sesion.

     Se busca el panel de confirmacion (que ahora SUSTITUYE al
     formulario) o el aviso de error. */
  if (pop.querySelector('[data-mz-pop-hecho]') || pop.querySelector('.mz-pop__aviso.is-error')) {
    abrir();
  } else if (!visto()) {
    /* El pop-up no se planta encima de otro dialogo.

       Quien toca "Carrito" nada mas llegar y se pone a revisar lo que
       dejo tiene el cajon abierto cuando vencen los seis segundos.
       Plantarle el pop-up encima le roba el foco a media compra y deja
       dos dialogos aria-modal abiertos a la vez. Se REPROGRAMA, no se
       descarta: el pop-up espera su turno y no se come la sesion —se
       marca como visto al mostrarlo—, que es lo que pasaria si
       simplemente se saltara el aviso de quien iba a suscribirse. */
    var turno = function () {
      if (window.mzDialogos.hayAbierto()) { setTimeout(turno, 4000); return; }
      abrir();
    };
    setTimeout(turno, espera * 1000);
  }

  pop.addEventListener('click', function (ev) {
    if (ev.target.closest('[data-mz-pop-cerrar]')) { ev.preventDefault(); cerrar(); }

    /* Copiar el codigo del cupon.

       El popup sale una vez por sesion y el codigo se enseña una sola
       vez: no hay correo de bienvenida detras. Si la persona no lo
       apunta, pierde su descuento. Un toque y lo tiene.

       Con respaldo para navegadores sin clipboard API o sin permiso:
       se selecciona el texto para que copiarlo a mano sea un gesto. */
    var btn = ev.target.closest('[data-mz-pop-copiar]');
    if (!btn) return;
    ev.preventDefault();
    var cod = pop.querySelector('[data-mz-pop-codigo]');
    if (!cod) return;
    var txt = (cod.textContent || '').trim();

    var avisar = function (texto, ok) {
      var antes = btn.dataset.original || btn.textContent;
      btn.dataset.original = antes;
      btn.textContent = texto;
      btn.classList.toggle('is-ok', ok !== false);
      setTimeout(function () { btn.textContent = antes; btn.classList.remove('is-ok'); }, 2600);
    };

    /* El gesto que se pide depende del aparato.

       El texto era fijo: "Copia con ⌘C". En Windows no existe esa tecla,
       y en un telefono no existe ningun teclado — y ahi es donde mas
       pasa, porque los navegadores de dentro de Instagram y Facebook
       pueden no traer navigator.clipboard y caen directos a este
       respaldo, que para una tienda que vive del trafico de Meta no es
       nada exotico. Ademas, en pantalla tactil seleccionar por Range no
       levanta por si solo la burbuja de "Copiar" del sistema: hay que
       mantener el dedo encima, y eso es lo que hay que pedir.

       Importa porque el codigo se enseña una sola vez por sesion: si el
       respaldo no se entiende, la persona pierde su descuento. */
    var gesto = function () {
      if (window.matchMedia('(pointer: coarse)').matches) return 'Mantén pulsado el código';
      return /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent || '')
        ? 'Copia con ⌘C'
        : 'Copia con Ctrl+C';
    };

    /* Respaldo cuando el navegador niega el portapapeles: se selecciona
       el codigo para que copiarlo sea un gesto.

       Y SE AVISA. La primera version dejaba este camino mudo: el texto
       quedaba seleccionado pero el boton seguia diciendo "Copiar", asi
       que parecia que no habia pasado nada. El aviso es honesto —no
       dice "¡Copiado!" porque no se copio— y pide el gesto que falta. */
    var aMano = function () {
      var listo = false;
      try {
        var r = document.createRange(); r.selectNodeContents(cod);
        var sl = window.getSelection(); sl.removeAllRanges(); sl.addRange(r);
        listo = true;
      } catch (e) {}
      avisar(listo ? gesto() : 'Apúntalo', false);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(txt).then(function () {
        avisar(btn.dataset.copiado || '¡Copiado!', true);
      }, aMano);
    } else {
      aMano();
    }
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && !pop.hidden) cerrar();
  });
  /* La trampa de foco del pop-up ya no vive aqui: es la de la pila
     compartida, que atiende solo al dialogo de encima. Dos trampas
     independientes se llamaban la una a la otra hasta desbordar. */
})();
